import { render, staticRenderFns } from "./manufacturing.vue?vue&type=template&id=29782d73&"
import script from "./manufacturing.vue?vue&type=script&lang=ts&"
export * from "./manufacturing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports